/* global REACT_APP_API_BASE_URL:true */
import request from "@/utils/request";

export async function getTransporterLoads({ page = 1, pageSize = 10, filter = "", sorting, status }) {
  const pageNumber = page - 1;

  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    const sortByDict = {
      pickupDropoffLocation: "shipment.pickupAddress.completedAddress",
    };

    const sortByValue = sortByDict[sortBy] || sortBy;
    Sorting = `${sortByValue} ${sortOrder}`;
  }

  const SkipCount = pageNumber * pageSize;

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    Sorting,
    Status: status,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads`, {
    method: "GET",
    params,
  });

  return result;
}

export async function getSingleTransporterLoad(loadId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/${loadId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function updateLocation(_, loadId, lat, long) {
  const result = await request(`${REACT_APP_API_BASE_URL}/api/Transporter/Loads/${loadId}`, {
    method: "POST",
    data: { latitude: lat, longitude: long },
  });

  return result?.data;
}

export async function getLoadsCount(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/count`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getAdminLoads(_, params) {
  const sorting = params.sorter ? params.sorter.split(":") : null;
  const filtering = params.filters ? params.filters : null;
  const paramsPayload = {
    PageNumber: params.current,
    PageSize: params.pageSize,
  };
  if (sorting) {
    const [column, order] = sorting;
    paramsPayload.column = column;
    paramsPayload.order = order;
  }
  if (filtering) {
    paramsPayload.filterBy = "";
    paramsPayload.filterValue = "";
    paramsPayload.filterCount = 0;

    filtering.forEach(filter => {
      paramsPayload.filterBy += `${filter.split(":")[0]}|`;
      paramsPayload.filterValue += `${filter.split(":")[1]}|`;
      paramsPayload.filterCount += 1;
    });

    paramsPayload.filterBy = paramsPayload.filterBy.slice(0, -1);
    paramsPayload.filterValue = paramsPayload.filterValue.slice(0, -1);
  }
  if (params.searchValue) {
    paramsPayload.search = params.searchValue.toLowerCase().trim();
  }

  const result = await request(`${REACT_APP_API_BASE_URL}/api/Loads`, {
    params: paramsPayload,
  });

  return result;
}

export async function updateLoadStatus(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/status/${params.id}`, {
    method: "PATCH",
    params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function changeAssignedDriver(loadId, userId) {
  const data = {
    userId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/change-driver/${loadId}`, {
    method: "PATCH",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }
}

export async function changeETARequest(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/request-eta-change/${loadId}`, {
    method: "POST",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }
}

export async function cancelRequest(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/request-cancel/${loadId}`, {
    method: "POST",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }
}

export async function changeAdminETARequest(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/update-eta/${loadId}`, {
    method: "PATCH",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }
}

export async function confirmDropOff(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/confirm-dropOff/${loadId}`, {
    method: "PATCH",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function confirmPickup(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/confirm-pickup/${loadId}`, {
    method: "PATCH",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function changeAdminActualDateRequest(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/update-date/${loadId}`, {
    method: "PATCH",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }
}

export async function toggleOpsAssisted(loadId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/toggle-ops-assisted/${loadId}`, {
    method: "PATCH",
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }
}

export async function forceAdminLocation(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/load-location/force`, {
    method: "POST",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }
  return result?.data;
}

export async function getLotExitSummary(loadId) {
  const params = {
    loadId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/lot-exits/summary`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getLotExits(loadId) {
  const params = {
    loadId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/lot-exits/by-load`, {
    method: "GET",
    params,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function completeLotExit(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/lot-exits/complete`, {
    method: "PATCH",
    data,
  });

  if (result?.error) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function toggleIsDamaged(loadId, reason) {
  const data = {
    reason,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/toggle-damage/${loadId}`, {
    method: "PATCH",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }
}

export async function updateLoadScanStatus(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/scanned-status/${loadId}`, {
    method: "PATCH",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function removePickup(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/remove-pickup/${loadId}`, {
    method: "PATCH",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function removeDropOff(loadId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/loads/remove-dropOff/${loadId}`, {
    method: "PATCH",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}
